import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    width: "100%",
    paddingInline: theme.spacing(4),
  },
  helper: {
    color: grey[700],
    fontSize: 14,
    textAlign: "center",
  },
  codesBoxWrapper: {
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
    border: `1px solid ${grey[200]}`,
    width: "100%",
    padding: theme.spacing(2),
  },
  codesBox: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    rowGap: theme.spacing(2),
    columnGap: theme.spacing(3),
    width: "100%",
  },
  code: {
    fontFamily: "monospace",
    fontSize: 15,
    letterSpacing: 1,
    color: theme.palette.common.black,
    textAlign: "left",
  },
  actionsRow: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1),
    width: "100%",
  },
  continueRow: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  icon: {
    width: 24,
    height: 24,
  },
  label: {
    color: theme.palette.contrastText.main,
    fontWeight: 500,
    letterSpacing: 1.1,
    textTransform: "uppercase",
    lineHeight: 1.2,
    marginBottom: theme.spacing(1.5),
  },
  codeWrapper: {
    backgroundColor: grey[300],
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
  },
  alert: {
    padding: theme.spacing(2, 1.5),
  },
  alertIcon: {
    marginRight: theme.spacing(1.5),
  },
}));
